
function DataInput() {
    /// <summary>
    /// This object provides js functions for the Widget.Input.DataInput.js. <br/>
    /// <br/>
    /// Author: ARF<br />
    /// Date: 4.9.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 4.9.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
    this.bsaid = -1;
}

DataInput.prototype = new vcTemplate();

DataInput.prototype.init = function () {
    /// <summary>
    /// This function inits the menu click handler. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
       
        me.showInfo("", "", false);
        //set the correct width
        me.visual.find("#div-data").width(me.width - parseInt(me.visual.find(".vc-list").width(), 10) - 40);
        //... and height
        me.visual.find("#div-signal-list,#div-data").height(me.height - 2);
        me.visual.find("#div-history-data, #div-chart").height(me.height - parseInt(me.visual.find("#div-edit").height()) - 40);
        me.visual.find(".vc-list-table").height(me.height - parseInt(me.visual.find(".vc-list-header").height()));

        me.visual.find("#btn-chart").off("click").on("click", function () { me.showChart($(this)); });
        me.visual.find("#btn-reload").off("click").on("click", function () { me.decide(); });
        me.visual.find("#btn-convert").off("click").on("click", function () { me.convert(); }).button();

        me.visual.find(".vc-list-table").off("click", "li").on("click", "li", function () { me.select($(this)) });
        me.visual.find(".vc-list-table").off("click", ".fa-info-circle").on("click", ".fa-info-circle", function (e) {
            me.vcVisual.showSignalAnalogSummaryDialog($(this).parents("li").data("id"));
            e.stopPropagation();
        });

        me.visual.find("#div-history-data").off("click", ".fa-edit").on("click", ".fa-edit", function () { me.edit($(this)) });
        me.visual.find("#div-history-data").off("click", ".fa-save").on("click", ".fa-save", function () { me.save($(this)) });


        me.fetchSignals();
        me.visual.find(".vc-filter").vcFilter({ callback: function () { me.filter(); } });


    return true;
    } catch (ex) { me.writeError('init', ex); return false }

}


DataInput.prototype.decide = function () {
    /// <summary>
    /// This function decides wether the chart or the entry list should get loaded <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        if (me.bsaid < 0) { return false }

        if (me.visual.find("#chk-chart").prop("checked")) {
            me.visual.find("#div-chart").show();
            me.visual.find("#div-history-data").hide();
            me.showChart();
        } else {
            me.visual.find("#div-chart").hide();
            me.visual.find("#div-history-data").show();
            me.fetchEntries(me.visual.find("#div-history-data"), parseInt(me.visual.find("#ddl-month").val(), 10), parseInt(me.visual.find("#ddl-year").val(), 10), parseInt(me.visual.find("#ddl-interval").val(), 10));
        }

        return true;
    } catch (ex) {
        me.writeError('decide', ex);
        return false;
    }

};


DataInput.prototype.filter = function () {
    /// <summary>
    /// This function filters the entries based on a given filter and filters the complete content of the list based on the vcFilter  <br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        //hide all
        me.visual.find(".vc-list-table .vc-list-item").removeClass("found").data("counter", 0).hide();

        //we add the 'found' class to all items we want to filter based on the vcfilter tags
        me.setTagFilter(".vc-filter", ".vc-list-table .vc-list-item", "found");

        me.visual.find(".vc-list-table .vc-list-item.found").show();
        me.visual.find(".vc-list-table .vc-list-item").removeClass("alt");
        me.visual.find(".vc-list-table .vc-list-item.found:even").addClass("alt");

        return true;
    } catch (ex) {
        me.writeError('filter', ex);
        return false;
    }

};


DataInput.prototype.fetchSignals = function () {
    /// <summary>
    ///  This function fetches all existing signals/meta types and generates the signal list. 
    /// </summary>
    var me = this;
    var item;
    var selectedItem = null;
    try {
        if (me.error) {
            return false;
        }
        me.visual.find(".vc-list-table").html("");
        me.visual.find(".vc-list-table").append($("<ul>"));

        me.visual.find(".vc-list ul").height(parseInt(me.visual.find(".vc-list-table").height()));

        var list = me.visual.find(".vc-list-table ul");

        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify({ "Type": 0 }),
       function (result) {
  
           if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
           if (result.rows == null) { list.html("<div class='note'>" + me.resources.noEntriesExist + "</div>"); return false; }
           //if (result.rows.count === 0) { me.showMessage(me.resources.noEntriesExist, false); return false; }
         
           for (var i = 0; i < result.rows.length; i++) {
               item = $("<li>",{"class": "vc-list-item", "data-id": result.rows[i].id, "html":  result.rows[i].name + " [" + result.rows[i].dims + "]"});
               if (result.rows[i].name.length > 25) {
                   item.css("font-size", "smaller");
               }
               item.append("<i  class='vc-list-icon popup fa-regular fa-info-circle color-font-secondary' title='" + me.resources.signalInfo + "'></i>");
                //store the first item for later
               if (i === 0) { selectedItem = item; }
               list.append(item);
           }
           me.visual.find(".vc-list-table .vc-list-item:odd").addClass("alt");
           //start with the first item
           if (selectedItem !== null) {me.select(selectedItem);}
           return true;
       });

        return true;
    } catch (ex) { me.writeError('fetchSignals', ex); return false }

}


DataInput.prototype.fetchEntries = function (target, mm, yyyy, months) {
    /// <summary>
    ///  This function fetches all existing entries and generates the entry list. 
    /// </summary>
    var me = this;
    var param;
    var tmpMM, tmpYYYY;
    try {
        if (me.error) {
            return false;
        }

        if (me.bsaid < 0) { return false }

        me.visual.find("#div-chart").hide();
        me.visual.find("#div-history-data").show();

        target.html(me.vcC.getLoadingIcon());

        param = { "Type": 1, "DataType": me.dataType, "bsaid": me.bsaid,"LoadMonths": months, "month": mm, "year":yyyy }
        window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
       function (result) {
           if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
    
           target.html("");
           tmpMM = param.month;
           tmpYYYY = param.year;
           for (var i = 0; i < months; i++) {
               //generate the input fields for one month
               target.append(me.generateInputFields(result, tmpMM, tmpYYYY, false));
               //decrease the current month
               tmpMM--;
               if (tmpMM < 1) {
                   tmpMM = 12;
                   tmpYYYY--;
               }
           }
           //init the button handlers
            me.visual.find(".btn-edit").off("click").on("click", function() { me.edit($(this)) });
            me.visual.find(".btn-save").off("click").on("click", function() { me.save($(this)) });
            me.visual.find(".btn-split").off("click").on("click", function () { me.split($(this)) });

            me.visual.find(".btn").button();
            me.visual.find("#div-data").show();

            me.visual.find(".wrapper").removeClass("alt");
            me.visual.find(".wrapper:even").addClass("alt");
            return true;
           });

        return true;
    } catch (ex) { me.writeError('fetchEntries', ex); return false }

}

DataInput.prototype.generateInputFields = function (data, mm, yyyy, editable) {
    /// <summary>
    ///  This function generates the input fields incl the buttons for one single . 
    /// </summary>
    var me = this;
    var wrapper, col,row,input;
    var month,endOfMonth,tmpDay;
    var firstWeekday;
    var weekCounter = 4;
    var dayCounter = 0, daysOfMonth = 0;
    var i;
    var firstDataIndex = 0, lastDataIndex = 0;
    var plausible;
    var headerCol;
    var sum = 0;
    try {
        if (me.error) {
            return false;
        }
       
        // first we need the number of days of the given month
        // so, we move one month foreward and then we take the latest day of the previous month ;-) 
        endOfMonth = new Date(yyyy, mm, 0);
        daysOfMonth = endOfMonth.getDate();

        month = new Date(yyyy, mm - 1, 1);
       
        for (i = 0; i < data.length; i++) {
            if (data[i].PointDate === ($.datepicker.formatDate('dd.mm.yy', month) + '')) {firstDataIndex = i;}
            if (data[i].PointDate === ($.datepicker.formatDate('dd.mm.yy', endOfMonth) + '')) {lastDataIndex = i;}
        }

        firstWeekday = month.getUTCDay();
        //we start with the first weekday (monday!)
        dayCounter = firstWeekday * -1;
        //let's decide how many columns we need
        if ((daysOfMonth + firstWeekday) > 28) { weekCounter = 5 }
        if ((daysOfMonth + firstWeekday) > 35) { weekCounter = 6 }

        wrapper = $("<div>", {"class": "wrapper", "data-mm": mm, "data-yyyy": yyyy});
        var header = $("<div>", { "class": "header" });
        headerCol = $("<div>", { "class": "header-column" });
        //add the header columns
        headerCol.append($("<span>", { "class": "month", "html": $.datepicker.regional[me.resources.langShortcut].monthNamesShort[mm-1] + ' ' + yyyy }));
        headerCol.append($("<div>", { "class": "btn btn-edit", "html": me.resources.editData }));
        headerCol.append($("<div>", { "class": "btn btn-save", "html": me.resources.save }));
        header.append(headerCol);

        header.append($("<div>", { "class": "header-column info-text", "html": me.resources.split + ": " ,"style": "text-align:right"}));

        headerCol = $("<div>", { "class": "header-column"  });
        headerCol.append($("<div>", { "class": "btn btn-split", "html": me.resources.splitNow }));
        headerCol.append($("<input>", { "class": "txtEnabled txt-split" }));
        header.append(headerCol);
    
        wrapper.append(header);
        wrapper.append($("<hr>", { "class": 'break-line' }));
    
        for (i = 0; i < weekCounter; i++) {
            col = $("<div>", { "class": "column" });
            for (var j = 0; j < 7; j++) {
                row = $("<div>", { "class": "row" });
                //we generate a new date for the current day
                tmpDay = new Date(month);
                tmpDay.setDate(tmpDay.getDate() + dayCounter);
                 // and use it for formatting the monthly date
                row.append($("<div>", { "class": "caption" }).html( me.resources.weekdays[j] + ', ' + $.datepicker.formatDate('dd.mm.', tmpDay)));
                //and formatting the row date
                input = $("<input>", { "class": "txtEnabled vc-grid-1col", "value": "", "data-date": $.datepicker.formatDate('dd.mm.yy', tmpDay) });
               
                plausible = true;

                //let's find the fetched value
                for (var k = firstDataIndex; k <=lastDataIndex; k++) {

                    if (data.length > k) {
                        if (data[k].PointDate === ($.datepicker.formatDate('dd.mm.yy', tmpDay) + '')) {
                       
                            if (data[k].Value !== null) {
                                input.val(Highcharts.numberFormat(data[k].Value, 2, ',', '.'));
                                input.data("old", Highcharts.numberFormat(data[k].Value, 2, ',', '.'));
                                //we sum up the values because we need them in the footer
                                sum += data[k].Value;
                            } else {
                                input.data("old", "");
                            }

                            if (data[k].Marker.Plausible === false) { plausible = false;}
                       
                        }
                    } else {
                        input.data("old", "");
                    }
                }
                //we mark the dates which are not within the current month separately
                if ((dayCounter < 0) || (dayCounter >= daysOfMonth)) {
                    row.addClass("hide");
                    input.prop("readonly", true).prop("disabled", true);
                } else {
                    if (editable === false) {
                        row.addClass("inactive");
                        input.prop("readonly", true).prop("disabled", true);
                    }
                }
                row.append($("<div>", { "class": "input" }).html(input));
                if (plausible === false) {
                    row.append(me.resources.iconInplausible);
                }
                col.append(row);
                dayCounter++;
            }
            wrapper.append(col);
         
        }
        //let's add a footer
        wrapper.append($("<div>", {"style": "clear:both"}));
        
        wrapper.append($("<span>", { "class": "span-sum", "html": me.resources.sum + ": " + Highcharts.numberFormat(sum, 2, ',', '.') }));
        wrapper.append($("<hr>", { "class": 'break-line' }));
        return wrapper;

    } catch (ex) {me.writeError('generateInputFields', ex); return "";}
};


DataInput.prototype.showChart = function () {
    /// <summary>
    ///  This function shows a daily chart for the selected signal over the selected period of time. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false;}

        var signalParam = { 'series': [] };
        signalParam.series.push({ 'bsaid': [me.bsaid], 'rule': '[bsaid=' + me.bsaid + ']', 'ruleType': 1, 'seriesType': 'column' });

        var param = { 'loggerID': me.blid, 'ExternalTooltip': false, 'fixTooltip': false, 'ShowInvalidValues': true, 'ShowPlotLines': true, 'datatype': 2, 'interval':3,
            'ShowEmptyChart': true, 'DecimalPlace': 3, 'HideNotAllowedIntervals': true, 'ShowIntervention':true, 'UseSimpleBottomLegend': true };
        
        var mm = parseInt(me.visual.find("#ddl-month").val(), 10);
        var yy = parseInt(me.visual.find("#ddl-year").val(), 10);
        var months = parseInt(me.visual.find("#ddl-interval").val(), 10);

        param.startDate = $.datepicker.formatDate('dd.mm.yy', new Date(yy, mm-months, 1));
        param.endDate = $.datepicker.formatDate('dd.mm.yy', new Date(yy, mm, 0));
        me.vcVisual.addVisualBaseByName('div-', 'VISUAL_RAMP_DAILY', 'chart', getCurrentTimestamp(), me.visual.find('#div-chart').height(), me.visual.find('#div-chart').width(), JSON.stringify(param), JSON.stringify(signalParam), 1);

        return true;
    } catch (ex) {
        me.writeError('showChart', ex);
        return false;
    }

};

DataInput.prototype.select = function (obj) {
    /// <summary>
    ///  This function is the click handler for the signal / meta type list . 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
    
        me.visual.find(".vc-list-table li").removeClass("selected");
        obj.addClass("selected");
        //store the signal id
        me.bsaid = parseInt(obj.data("id"), 10);

        me.visual.find("#btn-convert").button("enable");
        me.visual.find("#div-convert-note").html(me.resources.convertInfo).removeClass("note error").addClass("note");

        me.decide();
        return true;
    } catch (ex) {
        me.writeError('select', ex);
        return false;
    }

};


DataInput.prototype.edit = function (obj) {
    /// <summary>
    ///  This function enables the edit mode for one single monthly edit form. 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        obj.parents(".wrapper").find(".row").removeClass("inactive");
        obj.parents(".wrapper").find(".row input").prop("disabled", false).prop("readonly", false);
        obj.hide();
        obj.parents(".wrapper").find(".btn-save").show();

        return true;
    } catch (ex) {me.writeError('edit', ex);return false;}
};

DataInput.prototype.split = function (obj) {
    /// <summary>
    ///  This function splits the monhtly value into the single day input fields and adds a rounding correction on the first day. 
    /// </summary>
    var me = this;
    var wrapper;
    var val;
    var days = 0;
    var first = true;
    var bSplit = false;
    try {
        if (me.error) { return false; }

        wrapper = obj.parents(".wrapper");

        //get the number of days
        if (me.onlyFillEmptyDays) {
            wrapper.find(".row").each(function () { if ($(this).hasClass("hide") === false && $(this).find("input").val().length === 0) { days++;} });
        } else {
            wrapper.find(".row").each(function () { if ($(this).hasClass("hide") === false) { days++; } });
        }
      
        if (days === 0) {return false}

        wrapper.find(".fa-exclamation-triangle").hide();
        //start the edit mode
        me.edit(wrapper.find(".btn-edit"));

        var monthlyVal = me.vcC.cleanNumber(wrapper.find(".txt-split").val());

        if ((validateNumeric(monthlyVal) === false || isNaN(parseFloat(monthlyVal)))) {
            wrapper.find(".txt-split").addClass("error");
            return false;
        } else {
            wrapper.find(".txt-split").removeClass("error");
        }

        monthlyVal = monthlyVal.replace(",", ".");
        //calculate the single value
        val = parseFloat(me.vcC.cleanNumber(Highcharts.numberFormat(monthlyVal / days, 2, ",", ".")).replace(",", "."));

        wrapper.find(".row").each(function () {
            bSplit = false;
            if ($(this).hasClass("hide") === false) {
                if (me.onlyFillEmptyDays) {
                    if ($(this).find("input").val().length === 0) { bSplit = true;}
                } else { bSplit = true; }
            }
            if (bSplit) {
                if (first) {
                    //here we add the rounding correction
                   $(this).find("input").val(Highcharts.numberFormat(val + (monthlyVal - (val * days)), 2, ',', '.'));
                } else {
                    $(this).find("input").val(Highcharts.numberFormat(val, 2, ',', '.'));
                }
                first = false;
            }
        });
        return true;
    } catch (ex) { me.writeError('split', ex); return false }

}

DataInput.prototype.save = function (obj) {
    /// <summary>
    ///  This function generates a list of changed values and sends it to the server. 
    /// </summary>
    var me = this;
    var wrapper;
    var val;
    var oldVal;
    var input;
    var valid = true;
    var data = [];
 
    try {
        if (me.error) { return false;}

        wrapper = obj.parents(".wrapper");
        wrapper.find(".row").each(function() {
            if ($(this).hasClass("hide") === false) {
                input = $(this).find("input");
                val = me.vcC.cleanNumber(input.val());
                //get the old (loaded) value as well so we can compare if anything has changed
                if (input.data("old").length > 0) {

                    oldVal = me.vcC.cleanNumber(input.data("old"));
                } else {oldVal = ""}
                input.removeClass("error");

                if (val !== oldVal) {
                    if (val.length > 0 && ((validateNumeric(val) === false || isNaN(parseFloat(val))))) {
                        input.addClass("error");
                        valid = false;
                    } else {
                        data.push({ 'PointDate': input.data("date"), 'Value': val.replace(",", ".") });
                    }
                } 
            }
        });

        if (valid) {
            wrapper.find(".row").addClass("inactive");
            wrapper.find(".row input").prop("disabled", true).prop("readonly", true);
        } else {
            return false;
        }

        var param = { "Type": 1, "DataType": me.dataType, "bsaid": me.bsaid, "data": data, "month": parseInt(wrapper.data("mm"), 10), "year": parseInt(wrapper.data("yyyy"), 10) }

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
       function (result) {
           if (result === false) { me.showMessage(me.resources.err_saveData, true); return false; }
           me.fetchEntries(wrapper, parseInt(wrapper.data("mm"), 10), parseInt(wrapper.data("yyyy"), 10), 1);
           obj.hide();
           wrapper.find(".btn-edit").show();
           return true;
       });

        return true;
    } catch (ex) { me.writeError('save', ex); return false }

}



DataInput.prototype.convert = function () {
    /// <summary>
    ///  This function sends a request to the server for converting all found meta data to the new meta signal. 
    /// </summary>
    var me = this;
    var param;

    try {
        if (me.error) { return false; }

        if (me.bsaid < 0) { return false }

        me.visual.find("#btn-convert").button("disable");
        me.error = true;
        me.visual.find("#div-history-data, .vc-list-table").css("opacity", 0.5);


        param = { "Type": 2, "DataType": me.dataType, "bsaid": me.bsaid, "mtid": parseInt(me.visual.find("#ddl-meta-types").val(), 10)}
        me.visual.find("#div-convert-note").html(me.resources.waitForConversion).removeClass("error note").addClass("note");

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', 1, 2, JSON.stringify(param),
       function (result) {
           me.visual.find("#div-history-data, .vc-list-table").css("opacity", 1);
           me.error = false;
           if (result === null) { me.showMessage(me.resources.err_saveData, true); return false; }
           if (result === false) { me.showMessage(me.resources.err_saveData, true); return false; }

           if (result + '' !== "true") {
               me.visual.find("#div-convert-note").html(result).removeClass("note").addClass("error");
               return false;
           } else {
               me.visual.find("#div-convert-note").html(me.resources.conversionFinished).removeClass("note error").addClass("note");
               me.decide();
               me.visual.find("#btn-convert").button("enable");
           }
           return true;
       });

        return true;
    } catch (ex) {
         me.writeError('save', ex); return false }

}

DataInput.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find(".vc-list, #div-data").hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


